import { PRODUCT_VERSION } from '@core/constants/core';

export const setProductVersion = () => {
  localStorage.setItem(PRODUCT_VERSION, String(process.env.REACT_APP_PRODUCT_VERSION));
};
